import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import saveAs from 'file-saver';
import { Table } from 'primeng/table';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { JEService } from 'src/app/services/je-services.service';
// import { BankDetail } from '../../registration/bank-details/bankDetails';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';



@Component({
  selector: 'app-mi-physical-verfication-completed',
  templateUrl: './mi-physical-verfication-completed.component.html',
  styleUrls: ['./mi-physical-verfication-completed.component.scss']
})
export class MiPhysicalVerficationCompletedComponent implements OnInit {

  @ViewChild('dt', { static: true }) public miVerificationTable: Table;

  canEditFinanceDetails: boolean = false;
  basicDetailsForm: FormGroup;
  isSubmitted = false;
  editIcon: string = 'pi pi-fw pi-pencil';
  saveIcon: string = 'pi pi-fw pi-check';
  physicalVerficationApplications: any = [];
  mobilePhysicalVerficationApplicationsData: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];

  toggleEditFinanceDetails() {
    this.canEditFinanceDetails = !this.canEditFinanceDetails;
    if (!this.canEditFinanceDetails) {
      this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Finance Details Modified' });
    }
  }
  selectedApplications: any[];
  submitted: boolean;
  items: MenuItem[];
  appVerificationItems: MenuItem[];
  public userID: any;
  public jeLogin: boolean = false;
  public xenLogin: boolean = false;
  public ddAssociateLogin: boolean = false;
  public dimicadaLogin: boolean = false;

  public loading: boolean = false;
  public subscriptions: any = [];
  public subjectSub:any;
  public selectedYear:any;



  constructor(
    private messageService: MessageService, 
    private cryptoJsService: CryptoJsService,
    private confirmationService: ConfirmationService, 
    private jeService: JEService, 
    private router: Router, 
    private dashboard: DashboardService, 
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService
    ) { }

  ngOnInit(): void {
    this.clearSessionCoordinatesOnLoad();
    sessionStorage.setItem('isMIPhysicalVerPending', 'false');
    // this.miVerificationTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.physicalVerficationApplications, "Physical_Verification_List");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.physicalVerficationApplications, "Physical_Verification_List");
        }
      },
    ];

    const tokenData = sessionStorage.getItem('token') ? JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'))) : {}
    // console.log('token.role', tokenData?.role)
    if(tokenData && (tokenData.role == 'JE' || tokenData.role == 'CJE')){ 
      this.jeLogin = true
    }
    else if(tokenData && (tokenData.role == 'XEN' || tokenData.role == 'CXEN')){ 
     this.xenLogin = true
    }
    else if(tokenData && tokenData.role == 'DMICADA'){
      this.dimicadaLogin = true
    }
    else if(tokenData && tokenData.role == 'DD Associate'){
      this.ddAssociateLogin = true
    }
    
    // this.loadData();
    this.loadDataAndApplyFilter();
  }

  clearSessionCoordinatesOnLoad(){
    sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
    sessionStorage.removeItem('miPhysicalAppSDOGPSCoordinates');
    sessionStorage.removeItem('miPhysicalAppXENGPSCoordinates');
  }

  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {

        
        this.selectedYear = res;
        this.loadData();
        this.miVerificationTable.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }


  loadData(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (sessionStorage.getItem("MIPhysicalVerificationApproved") != 'null' && (sessionStorage.getItem("MIPhysicalVerificationApproved") && 
    JSON.parse(window.sessionStorage.getItem('MIPhysicalVerificationApproved'))[0]?.FinYear == this.selectedYear)) {
      this.physicalVerficationApplications = JSON.parse(
        window.sessionStorage.getItem('MIPhysicalVerificationApproved')
      );
      this.mobilePhysicalVerficationApplicationsData = JSON.parse(
        window.sessionStorage.getItem('MIPhysicalVerificationApproved')
      ).filter(val => val.FinYear==window.sessionStorage.getItem('financialYear'));

      // this.activityRecordService.activityRecord(this.userID, 'Farmer Applications For Approval (Pending)', '', new Date(), 'Success');

    }else{
      let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
      this.userID = JSON.parse(payload)?.sub;
      // this.loader.start();
      this.loading = true;
      let sub = this.jeService.getApplicationsForPhysicalVerification(JSON.parse(payload)?.sub, 'Approved', this.selectedYear)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          // this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification (Approved)', '', new Date(), 'Success');
          this.loading = false;
          this.physicalVerficationApplications = data;
          // this.mobilePhysicalVerficationApplicationsData = data;
          this.mobilePhysicalVerficationApplicationsData = this.physicalVerficationApplications.filter(val => val.FinYear==this.selectedYear);
  
          
          this.physicalVerficationApplications.forEach(e=>{
            if(e.RegDate) {
              e.RegDate_sort = new Date(e.RegDate);
              e.registerationDate_filter = e.RegDate_sort.toString().substring(4, 24)
            }
            e.AssignedDate = new Date(e?.AssignedDate);
            e.ActionDate = new Date(e?.ActionDate);
          })

          if (this.physicalVerficationApplications?.length > 0) {
            sessionStorage.setItem(
              'MIPhysicalVerificationApproved',
              JSON.stringify(this.physicalVerficationApplications)
            );
          }
          
        },
        error: (err) => {
          this.physicalVerficationApplications = [];
          this.mobilePhysicalVerficationApplicationsData = [];
          this.loading = false;
          this.loader.close();
          // this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification (Approved)', '', new Date(), err);
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
          }
        });
  
        this.subscriptions.push(sub);
    }
    
  }

  selectPhysicalVerAppln(application: any) {
    this.activityRecordService.activityRecord(this.userID, 'MI Physical Verification Action Start', application?.AppID, new Date(), 'Success');
    if (application.AutoId) {
      let encryptedAutoId = this.cryptoJsService.Encrypt(application.AutoId.toString());
      let encryptedAppId = this.cryptoJsService.Encrypt(application.AppID.toString());
      this.router.navigate([this.router.url.split('/')[1], 'application'], { queryParams: { autoId: encryptedAutoId, appId: encryptedAppId } });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
    }

  }

  selectFarmerApplication(application) {
    // if (application.AppID) {
    //   const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.AppID)]));
    //   window.open(link, '_blank');
    // } else {
    //   this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    // }
    // if(application.AppID){
    //   this.loader.start();
    //   this.dashboard
    //   .getMIDetailByAppID(application.AppID)
    //   .pipe(first())
    //   .subscribe({
    //     next: (res) => {
    //       this.loader.close();
    //       const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.AppID), ,res[0]?.VendorId,res[0]?.ProgId,res[0]?.User_ID,res[0]?.AutoId]));
    //       window.open(link, '_blank');
    //     },
    //     error: (err) => {
    //       this.loader.close();
    //       console.log("error", err);
    //       this.messageService.add({
    //         severity: 'error',
    //         summary: 'Error Message',
    //         detail: err,
    //       });
    //     },
    //   });
    // }
    //  else {
    //   this.loader.close();
    //   this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    // }
    if (application?.AppID) {
      // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application?.AppID)]));
      const link = this.router.serializeUrl(
        this.router.createUrlTree([
          this.router.url.split('/')[1],
          'print',
        ],  { queryParams: { appId:this.cryptoJsService.Encrypt(application.AppID.toString()) } }));
      window.open(link, '_blank');
    }
    else{
      this.messageService.add({
        summary: 'Error Message',
        severity: 'info',
        detail: 'Application Id Not Found',
      });
    }
  }

  deletePhysicalVerAppln(application: any) {

  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'AppID', header: 'App ID' },
      { field: 'RegDate', header: 'RegDate' },
      { field: 'Block', header: 'Block' },
      { field: 'Village', header: 'Village' },
      { field: 'District', header: 'District' },
      { field: 'FarmerName', header: 'Farmer Name' },
      { field: 'Caste_Description', header: 'Caste' },
      { field: 'ProgrammeName', header: 'Programme Name' },
      { field: 'Status', header: 'Status' },
      { field: 'Targetdays', header: 'Target_Days' },
      { field: 'PendingCompletedDays', header: 'Pending_Days' },
      { field: 'VendorName', header: 'Vendor' },
      { field: 'Scheme', header: 'Scheme' },
      { field: 'AutoId', header: 'Auto Id' },
      { field: 'PhyVerificationStatus', header: 'PhyVerificationStatus' },
      { field: 'Status_Ar', header: 'Current Status' }
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 6 }});
        doc.save(`${filename}.pdf`);
      })
    })
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "App ID": d.AppID,
          "Reg_Date": d.RegDate,
          "Block": d.Block,
          "Village": d.Village,
          "District": d.District,
          "Farmer Name": d.FarmerName,
          "Caste": d.Caste_Description,
          "Programme Name": d.ProgrammeName,
          "Status": d.Status,
          "Target_Days": d.Targetdays,
          "Pending_Days": d.PendingCompletedDays,
          "Vendor": d.VendorName,
          "Scheme": d.Scheme,
          "Auto Id": d.AutoId,
          "PhyVerificationStatus": d.PhyVerificationStatus,
          "Current Status": d.Status_Ar
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  refreshTable() {
    sessionStorage.removeItem('MIPhysicalVerificationApproved');
    // this.miVerificationTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
    this.loadData();
  }
  rowBackgroundColor(product){
    if(product.PendingCompletedDays<=-2 && product.Status_Ar=="P"){
      //red color
      return "#ff8080"
    }
    else if(product.PendingCompletedDays==-1 && product.Status_Ar=="P"){
      //orange color
      return "#ffc966"
    }
    else if(product.PendingCompletedDays>=-1 && (product.Status_Ar=="C"||product.Status_Ar=="A")){
      //green color
      return "#99e699"
    }
    else if(product.PendingCompletedDays<=-2 && (product.Status_Ar=="C"||product.Status_Ar=="A")){
      //light red color
      return "#ffb3b3"
    }
    else {
      return "#ffff"
    }
  }

  mobileSearch(value) {
    this.mobilePhysicalVerficationApplicationsData = this.physicalVerficationApplications.filter((data:any)=>{
      if(data.AppID.toString().toLowerCase().includes(value.toLowerCase())
       || data.RegDate.toString().toLowerCase().includes(value.toLowerCase())
       || data.FarmerName.toString().toLowerCase().includes(value.toLowerCase())
       || data.Village.toString().toLowerCase().includes(value.toLowerCase())
       || data.VendorName.toString().toLowerCase().includes(value.toLowerCase())
       || data.Scheme.toString().toLowerCase().includes(value.toLowerCase())
       || data.AutoId.toString().toLowerCase().includes(value.toLowerCase())
       ) {
       return data
     }
   })
   }

}
